import styled, { css } from 'styled-components/macro';

import { Link } from 'react-router-dom';

const SLink = styled(Link)`
  width: 100%;
  height: 100%;
  display: block;
  color: #283f5f;
  font-size: 13px;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: #283f5f;
  }
  .search-highlight {
    background: inherit;
    font-weight: bold;
    color: #283f5f;
  }
`;

const Item = styled.li`
  cursor: ${({ cursor }) => cursor || 'pointer'};
  display: block;
  height: auto;
  color: #283f5f;
  font-size: 14px;
  padding: 0 10px;
  white-space: 'normal';
  word-wrap: 'normal';
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.3;
  min-height: 40px;
  &:first-child {
    border-radius: 5px 5px 0 0;
  }
  &:last-child {
    border-radius: 0 0 5px 5px;
  }
  ${({ isActive }) =>
    isActive &&
    css`
      color: rgba(0, 0, 0, 0.85);
      background: rgba(0, 0, 0, 0.1);
    `}
  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: bold;
    `}
`;

const Input = styled.input`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 50px;
  padding-left: 10px;
  border: none;
  font-size: 14px;
  background-color: transparent;
  color: #FFFF;
  // transition: background-color 0.3s ease 0s;
  border-bottom: 1px solid #FFF;
  :hover {
    color:#00F7F0;
  }
  ::placeholder {
    color: #FFF;
    font-style: italic;
    opacity: 0.9;
  }
`;

const MenuWrapper = styled.div`
  box-sizing: border-box;
  padding: 20px;
  position: absolute;
  display: flex;
  width: 100%;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.2);
  max-height: 288px;
  background: rgba(255, 255, 255, 0.95);

  display: ${({ isOpen }) => !isOpen && `none`};
`;
const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;

  /*IE11 fix IE11: Child containers overflow when max-height on parent is reached https://github.com/philipwalton/flexbugs/issues/216 */
  max-height: 248px;
`;

const SearchIconWrapper = styled.div`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 10px;
  top: 0;
  width: 47px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;

  /*IE11: Column flex items set to align-items: center overflow their container https://github.com/philipwalton/flexbugs#flexbug-2 */
  max-width: 47px;
`;

const Root = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  z-index: 1000;
`;

export { SLink, Menu, MenuWrapper, Input, Item, SearchIconWrapper, Root };
